var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg40 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#00A4EA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.027 28.845c-.715 0-.594-.27-.84-.95l-2.103-6.92 16.185-9.602",
  fill: "#C8DAEA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.028 28.845c.552 0 .796-.252 1.104-.552l2.942-2.861-3.67-2.214",
  fill: "#A9C9DD"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.402 23.22l8.894 6.57c1.015.56 1.748.27 2-.941l3.621-17.061c.37-1.486-.566-2.16-1.537-1.72L9.12 18.266c-1.45.582-1.442 1.391-.264 1.752l5.456 1.703 12.63-7.968c.596-.362 1.143-.168.694.231",
  fill: "url(#40_svg__paint0_linear_5493_87321)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "40_svg__paint0_linear_5493_87321",
  x1: 23.84,
  y1: 18.732,
  x2: 27.284,
  y2: 26.579,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFF7FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMwMEE0RUEiLz4KPHBhdGggZD0iTTE3LjAyNjcgMjguODQ1QzE2LjMxMTYgMjguODQ1IDE2LjQzMzIgMjguNTc1MSAxNi4xODY1IDI3Ljg5NDJMMTQuMDg0IDIwLjk3NDZMMzAuMjY4OCAxMS4zNzI4IiBmaWxsPSIjQzhEQUVBIi8+CjxwYXRoIGQ9Ik0xNy4wMjgzIDI4Ljg0NDlDMTcuNTgwMSAyOC44NDQ5IDE3LjgyMzggMjguNTkyNSAxOC4xMzE4IDI4LjI5MzFMMjEuMDc0NSAyNS40MzE3TDE3LjQwMzkgMjMuMjE4MyIgZmlsbD0iI0E5QzlERCIvPgo8cGF0aCBkPSJNMTcuNDAyMiAyMy4yMTk1TDI2LjI5NjQgMjkuNzkwN0MyNy4zMTE1IDMwLjM1MDcgMjguMDQzOCAzMC4wNjA3IDI4LjI5NjcgMjguODQ4NUwzMS45MTcyIDExLjc4NzdDMzIuMjg3OCAxMC4zMDE2IDMxLjM1MDcgOS42MjczNyAzMC4zNzk2IDEwLjA2ODJMOS4xMjA0OSAxOC4yNjU2QzcuNjY5MzggMTguODQ3NyA3LjY3ODAyIDE5LjY1NzQgOC44NTYwMiAyMC4wMThMMTQuMzExNiAyMS43MjA5TDI2Ljk0MTggMTMuNzUyN0MyNy41MzgxIDEzLjM5MTEgMjguMDg1NCAxMy41ODUzIDI3LjYzNjMgMTMuOTg0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNTQ5M184NzMyMSkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl81NDkzXzg3MzIxIiB4MT0iMjMuODQiIHkxPSIxOC43MzE4IiB4Mj0iMjcuMjg0MyIgeTI9IjI2LjU3OTQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0VGRjdGQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { Svg40 as ReactComponent };